import axios from "axios";
import { IChat } from "../interfaces/chat";
export const sendChatMessage = async (newChat: IChat) => {
  const result = await axios.post("/chat/doctor", newChat);
  return result;
};

// eslint-disable-next-line import/no-anonymous-default-export
export default { sendChatMessage };
